import { SIGN_OUT } from "../constants";

const handleError = (code, dispatch) => {
  if (code === 401) {
    dispatch({ type: SIGN_OUT });
  }
};
export default handleError;
